// extracted by mini-css-extract-plugin
module.exports = {"rowTitle":"StaticTopics_rowTitle__UbaGM","contentWrapper":"StaticTopics_contentWrapper__kLnR6","contentWrapperEn":"StaticTopics_contentWrapperEn__sg9LF"};